require('./app');

import VU from "./validation";

/*!
 * Форма регистрации
 */
(($) => {
	"use strict";

	let countrySelector = $('#country');
	let regionSelector = $('#region');
	let phoneTypeInput = $('[type="tel"]');

	VU.searchRequired();

	// убирать субъект РФ, если страна не Россия
	regionCheck();
	countrySelector.on('change', () => {
		regionCheck();
	})

	phoneTypeInput.mask("+7(999) 999-9999");
	phoneTypeInput.keypress(function (evt) {
		let ASCIICode = (evt.which) ? evt.which : evt.keyCode;
		if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
			evt.preventDefault();
	});

	function regionCheck() {
		let select = $('#country option:selected');
		if (select.val() !== 'RU' && select.val() !== 'Выбрать') {
			VU.searchRequired();
			if (VU.validations.hasOwnProperty('region')) {
				delete VU.validations['region'];
			}
            regionSelector.addClass('disabled')
                .removeClass('is-invalid')
                .val('93')
                .prop('disabled', true)
                .prop('required', false);
            $('label[for="region"] > span').addClass('visually-hidden');
			VU.canSubmit()
		} else {
			VU.searchRequired();
			regionSelector.removeClass('disabled')
				.prop('disabled', false)
				.prop('required', false);
			$('label[for="region"] > span').removeClass('visually-hidden');
		}
	}
})($);
